import { render, staticRenderFns } from "./red-packet-close.mpx?vue&type=template&id=73f263dc&scoped=true&isComponent&outputPath=components%2Fred-packet-close937b2cc8%2Findex"
import script from "./red-packet-close.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fred-packet-close937b2cc8%2Findex"
export * from "./red-packet-close.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fred-packet-close937b2cc8%2Findex"
import style0 from "./red-packet-close.mpx?vue&type=style&index=0&id=73f263dc&prod&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m937b2cc8%22%7D&isComponent&outputPath=components%2Fred-packet-close937b2cc8%2Findex"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f263dc",
  null
  
)

export default component.exports